// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"f778c666","187":"d69c5c06","224":"8e1ce4ae","376":"515d68e3","953":"eccd9c43"}[chunkId] + ".chunk.css";
};